"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconMap = exports.IconType = void 0;
var icons = require("./../../../styles/att-icons.css");
var IconType;
(function (IconType) {
    IconType["SAVINGICON"] = "savingicon";
    IconType["TVICON"] = "tvicon";
    IconType["PHONEFRONTRING"] = "phoneFrontRing";
})(IconType = exports.IconType || (exports.IconType = {}));
exports.iconMap = new Map([
    [IconType.SAVINGICON, icons.attIconSavingsWhite],
    [IconType.TVICON, icons.attIconTvOff],
    [IconType.PHONEFRONTRING, icons.attIconPhoneFrontRing],
]);
//# sourceMappingURL=BannerProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Banner/BannerProps.js
// module id = 1092
// module chunks = 8